import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Controller, Control, FieldPath, FieldValues } from 'react-hook-form';

type PhonePrefix = {
  dialCode: string;
  flag: string;
};

export const PHONE_PREFIXES: PhonePrefix[] = [
  { flag: '🇨🇿', dialCode: '+420' },
  { flag: '🇸🇰', dialCode: '+421' },
  { flag: '🇩🇪', dialCode: '+49' },
  { flag: '🇦🇹', dialCode: '+43' },
  { flag: '🇵🇱', dialCode: '+48' },
  { flag: '🇭🇺', dialCode: '+36' },
  { flag: '🇺🇦', dialCode: '+380' },
  { flag: '🇬🇧', dialCode: '+44' },
  { flag: '🇫🇷', dialCode: '+33' },
  { flag: '🇳🇱', dialCode: '+31' },
  { flag: '🇧🇪', dialCode: '+32' },
  { flag: '🇨🇭', dialCode: '+41' },
  { flag: '🇩🇰', dialCode: '+45' },
  { flag: '🇺🇸', dialCode: '+1' },
];

export const getDefaultPhonePrefix = (): string => {
  const map: Record<string, string> = { cs: '+420', sk: '+421', de: '+49', pl: '+48' };
  const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const lang of languages) {
    const code = lang.toLowerCase().split('-')[0];
    if (map[code]) {
      return map[code];
    }
  }
  return '+420';
};
export const PHONE_LENGTH_BY_PREFIX: Record<string, { min: number; max: number }> = {
  '+420': { min: 9, max: 9 },
  '+421': { min: 9, max: 9 },
  '+49': { min: 3, max: 12 },
  '+43': { min: 4, max: 13 },
  '+48': { min: 9, max: 9 },
  '+36': { min: 8, max: 9 },
  '+380': { min: 9, max: 9 },
  '+44': { min: 10, max: 10 },
  '+33': { min: 9, max: 9 },
  '+31': { min: 9, max: 9 },
  '+32': { min: 8, max: 9 },
  '+41': { min: 9, max: 9 },
  '+45': { min: 8, max: 8 },
  '+1': { min: 10, max: 10 },
};

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPath<T>;
};

const PhonePrefixAutocomplete = <T extends FieldValues>({ control, name }: Props<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={PHONE_PREFIXES}
          value={PHONE_PREFIXES.find(p => p.dialCode === field.value) ?? PHONE_PREFIXES[0]}
          onChange={(_, newValue) => field.onChange(newValue?.dialCode ?? null)}
          getOptionLabel={option => `${option.flag}  ${option.dialCode}`}
          renderOption={(props, option) => (
            <li {...props} key={option.dialCode}>
              <span style={{ marginRight: 8, fontSize: 18 }}>{option.flag}</span>
              <span style={{ marginRight: 8, fontWeight: 600 }}>{option.dialCode}</span>
            </li>
          )}
          renderInput={params => <TextField {...params} placeholder="+420" sx={{ width: 118 }} />}
          isOptionEqualToValue={(option, value) => option.dialCode === value.dialCode}
          autoHighlight={true}
          disableClearable
        />
      )}
    />
  );
};

export default PhonePrefixAutocomplete;
